import { createApi } from "@reduxjs/toolkit/query/react";
import createBaseQuery from "./createBaseQuery";
const DEFAULT_LIMIT = 1000;
const DEFAULT_BATCH_SIZE = 50;
export function createAuditLogsApi(baseUrl) {
    const auditLogsApi = createApi({
        reducerPath: `auditLogsApi_${baseUrl}`,
        baseQuery: createBaseQuery(baseUrl),
        tagTypes: [
            "AuditLogs"
        ],
        endpoints: (build)=>({
                getEntropyLogs: build.query({
                    query: (params)=>({
                            url: "api/v1/entropy/logs",
                            method: "GET",
                            params: {
                                start_epoch_seconds: params.start_epoch_seconds,
                                end_epoch_seconds: params.end_epoch_seconds,
                                limit: params.limit ?? DEFAULT_LIMIT,
                                batch_size: params.batch_size ?? DEFAULT_BATCH_SIZE,
                                batch_number: (params.batch_number ?? 1) - 1,
                                ...params.node_id ? {
                                    node_id: params.node_id
                                } : {}
                            }
                        }),
                    providesTags: [
                        "AuditLogs"
                    ],
                    transformResponse: (response)=>{
                        // EntropyAuditEventsRes is flattened - it's directly a Record<string, EntropyRequestEvent[]>
                        const eventArrays = Object.values(response);
                        const allEvents = eventArrays.flat();
                        // Sort by timestamp descending (most recent first)
                        return allEvents.sort((a, b)=>new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime());
                    }
                })
            })
    });
    return auditLogsApi;
}
